// DateRangePickerComponent.js
import React, { useRef, useEffect } from 'react';
import $ from 'jquery';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap-daterangepicker';

const DateRangePickerComponent = ({ onDateChange, initialStartDate, initialEndDate }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const $input = $(inputRef.current);

    const startMoment = initialStartDate ? moment(initialStartDate) : moment();
    const endMoment = initialEndDate ? moment(initialEndDate) : moment();

    $input.daterangepicker(
      {
        startDate: startMoment,
        endDate: endMoment,
        opens: 'right',
        autoUpdateInput: true,
        locale: {
          format: 'MM/DD/YYYY',
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
          ],
          'All': [moment('1970-01-01'), moment()],
        },
      },
      (start, end) => {
        $input.val(start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY'));
        onDateChange(start.toDate(), end.toDate());
      }
    );

    if (initialStartDate && initialEndDate) {
      $input.val(startMoment.format('MM/DD/YYYY') + ' - ' + endMoment.format('MM/DD/YYYY'));
    }
  }, [onDateChange, initialStartDate, initialEndDate]);

  const handleOpenPicker = (e) => {
    if (inputRef.current) {
      const drp = $(inputRef.current).data('daterangepicker');
      if (drp) {
        drp.show();
      }
    }
  };

  return (
    <div className="form-group" style={{ margin: 0 }}>
      <div
        className="input-group"
        onClick={handleOpenPicker}
        style={{ cursor: 'pointer' }}
      >
        <span
          className="input-group-text"
          onClick={handleOpenPicker}
          style={{ cursor: 'pointer' }}
        >
          <i className="fa fa-calendar" />
        </span>
        <input
          type="text"
          className="form-control"
          ref={inputRef}
          placeholder="Select date range"
          readOnly
          onClick={handleOpenPicker}
          style={{ maxWidth: '195px', cursor: 'pointer' }}
        />
      </div>
    </div>
  );
};

export default DateRangePickerComponent;
